import React from 'react'
import Navbar from './Navbar'

const Interests = () => {
    return (
        <section className="resume-section" id="interests">
            <Navbar />
            <div className="resume-section-content">
                <h2 className="mb-5">Interests</h2>
                <p>Apart from being a web developer, I enjoy most of my time being outdoors. I enjoy mountain biking,
                    free climbing, and Trekking</p>

                <p className="mb-0">When forced indoors, I follow a number of sci-fi and fantasy genre movies and television
                shows, I am an aspiring chef, and I spend a large amount of my free time exploring the latest
                    technology advancements in the Software Applications.</p>
                <p className="mb-0 text-primary">I love to play Computer and Mobile games.</p>
            </div>
        </section>
    )
}

export default Interests
